export default __webpack_public_path__ + "static/media/ENTREVISTA-EVALDO.6a8abe79.jpeg";